import { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { BreadCrumbs } from '../Layout/Header/BreadCrumbs';

import { BoxBodyContainer, TitleHeaderBox } from '@components/Box';
import { BreadcrumbsContainer } from '@components/BreadcrumbsContainer';
import { DynamicRecordFilter } from '@components/Grid';
import { routes } from '@config/routes';
import { loadConfig } from '@utils/configLoader';
import { getAccessCredential } from 'src/auth/utils/inMemoryTokenStore';

const config = await loadConfig();

export const AgedReceivables = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const token = getAccessCredential()?.value;
  const [dataUrlQueryFilter, setDataUrlQueryFilter] = useState<string>('');
  const [dateAsOf, setDateAsOf] = useState<string>('');
  const iframeUrl = token
    ? `${config.ReportsBaseUrl}?token=${token}&report=aged-receivables${
        dateAsOf ? `&asOfDate=${dateAsOf}` : ''
      }`
    : `${config.ReportsBaseUrl}`;

  useEffect(() => {
    fetch(`${iframeUrl}${dataUrlQueryFilter}`), {}, [dataUrlQueryFilter];
  });

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.src = iframeUrl;
    }
  }, [iframeUrl]);

  useEffect(() => {
    let tempDataUrlQueryFilter = '';
    if (dateAsOf) {
      tempDataUrlQueryFilter += `&asOfDate=${dateAsOf}`;
    }
    setDataUrlQueryFilter(tempDataUrlQueryFilter);
  }, [dateAsOf]);

  const baseBreadCrumbs = [{ link: 'Reports', to: '' }];

  const isOnRootPath = location.pathname === routes.RPT_AGEDRECEIVABLES;

  const breadCrumbLinks = isOnRootPath
    ? baseBreadCrumbs
    : [
        ...baseBreadCrumbs,
        { link: 'Aged Receivables', to: routes.RPT_AGEDRECEIVABLES },
      ];

  return (
    <div className="p-4 space-y-4">
      <BreadcrumbsContainer>
        <div className="lg:text-sm md:text-sm text-xs text-gray-500">
          Reports
        </div>
        <div className="lg:flex md:flex hidden">
          <BreadCrumbs links={breadCrumbLinks} />
        </div>
      </BreadcrumbsContainer>

      <BoxBodyContainer>
        <TitleHeaderBox Title="Aged Receivables" />

        <div className="p-8 bg-white rounded-b-xl space-y-4 rounded-tr-xl">
          {!token && <div>No authentication token available</div>}
          <div className="w-1/2">
            <DynamicRecordFilter
              label="Filters"
              filters={[
                {
                  label: 'as of',
                  type: 'date',
                  value: dateAsOf,
                  onChange: (e) => {
                    setDateAsOf(e.target.value);
                  },
                },
              ]}
              onFilter={() => {
                setDataUrlQueryFilter(`&asOfDate=${dateAsOf}`);
              }}
              onClear={() => {
                setDateAsOf('');
              }}
            />
          </div>
          <iframe
            ref={iframeRef}
            src={iframeUrl}
            width="100%"
            height="900px"
            frameBorder="0"
            title="Aged Receivables Report"
          ></iframe>
        </div>
      </BoxBodyContainer>
      <Outlet />
    </div>
  );
};
